import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import { hasValue } from '../../../utils/NumberUtil'
import NetworkAction from '../../../referencial/components/network/actions/NetworkAction'
import { StyledFieldSet, StyledLegend, StyledSpan } from '../../../components/StyledElements'
import PropTypes from 'prop-types'
import { Button, Grid, Stack } from '@mui/material'
import { BSS, CONVENTION_NOMMAGE_1, CONVENTION_NOMMAGE_2, STATIONS, DEPARTMENTS, CITIES } from 'traitements/constants/TraitementConstants'
import { Warning } from '@mui/icons-material'
import { CardTable } from 'components/datatable/NewTable'
import RadioButtons from 'components/forms/RadioButtons'
import Checkbox from 'components/forms/Checkbox'
import { readImportCsvStationsCodes } from 'import/components/utils/ImportUtils'
import { uniq } from 'lodash'
import { exportFile } from 'utils/ExportDataUtil'

const LENGHT_NEW_CODE_BSS = 10

const AddPiezoStepOptionsTreatmentAdes = ({
    station,
    filters,
    changeFilters,
    newJob,
    setNewJob,
    listStation,
    setListStation,
}) => {
    const {
        cities,
    } = useSelector(store => ({
        pluviometryDataTypes: store.PluviometryReducer.pluviometryDataTypes,
        cities: store.CityReducer.cities,
    }), shallowEqual)
    useEffect(() => {
        if (!filters?.stationsMode) {
            changeFilters({ stationsMode: CITIES })
        }
    }, [])
    const dispatch = useDispatch()

    const {
        networks,
    } = useSelector(store => ({
        networks: store.NetworkReducer.networks,
    }), shallowEqual)


    useEffect(() => {
        if (!networks.length) {
            dispatch(NetworkAction.fetchNetworks())
        }
    }, [])

    const oldCodeWithoutDesignation = hasValue(station.code) && station.code.length === CONVENTION_NOMMAGE_1 && !station.code.startsWith(BSS) && station.code[5] === CONVENTION_NOMMAGE_2

    const isNotBss = hasValue(station.code) && station.code.length !== LENGHT_NEW_CODE_BSS


    const isInputMode = [STATIONS, DEPARTMENTS].includes(filters.stationsMode)

    const [newCode, setNewCode] = useState('')

    const handleAdd = () => {
        if (!newCode) return
        const key = filters.stationsMode === DEPARTMENTS ? DEPARTMENTS : filters.stationsMode
        setListStation(prev =>
            prev.map(item => {
                if (item[0] !== key) return item
                if (item[1].includes(newCode)) return item
                return [item[0], [...item[1], newCode]]
            }),
        )

        setNewCode('')
    }

    const onChangeBssFile = e => {
        readImportCsvStationsCodes(e, { importFile: e.target }, (codes) => {
            const key = filters.stationsMode === DEPARTMENTS ? DEPARTMENTS : filters.stationsMode
            setListStation(prev =>
                prev.map(item =>
                    item[0] === key ? [item[0], uniq([...item[1], ...codes])]: item,
                ),
            )
        })
    }

    const changeJob = (changes) => setNewJob({ ...newJob, ...changes })

    const codesTypes = [
        { code: CITIES, name: i18n.cities },
        { code: STATIONS, name: i18n.stations },
        { code: DEPARTMENTS, name: i18n.departments },
    ]

    const onDeletePiezoCode = ({ code }) => {
        const key = filters.stationsMode === DEPARTMENTS ? DEPARTMENTS : filters.stationsMode
        setListStation(prev =>
            prev.map(item => item[0] === key ? [item[0], item[1].filter(p => p !== code)] : item,
            ),
        )
    }

    const currentList = listStation.find(([key]) => key === filters.stationsMode)?.[1] ?? []

    const stationsCodes = currentList.map(code => ({ code }))
    return (
        <>
            <StyledFieldSet>
                <StyledLegend>
                    <StyledSpan>{i18n.description}</StyledSpan>
                </StyledLegend>
                <Grid container mb={2} spacing={8}>
                    <Grid size={12}>
                        <Input
                            title={i18n.name}
                            obligatory
                            value={newJob.name}
                            onChange={v => changeJob({ name: v })}
                        />
                    </Grid>

                </Grid>
            </StyledFieldSet>
            <StyledFieldSet>
                <StyledLegend>
                    <StyledSpan>{i18n.options}</StyledSpan>
                </StyledLegend>
                <Grid container mb={2} justifyContent='space-between' spacing={2}>
                    <Grid size={4}>
                        <RadioButtons
                            elements={codesTypes}
                            selected={filters.stationsMode}
                            onChange={v => changeFilters({ stationsMode: v })}
                            title={i18n.schemeAgencyID}
                        />
                    </Grid>
                    <Grid size={4}>
                        <Checkbox
                            checked={filters.doNotImportClosedStations}
                            label={i18n.doNotImportClosedStations}
                            onChange={v => changeFilters({ doNotImportClosedStations: v })}
                        />
                    </Grid>
                </Grid>
                <Grid container mb={2} spacing={8}>
                    <Grid size={6}>
                        {isInputMode ? (
                            <Input
                                id='txtAddHydroCode'
                                type='text'
                                value={newCode}
                                onChange={v => setNewCode(v)}
                                title={i18n.code}
                                obligatory
                                onEnterKeyPress={handleAdd}
                                noSpace
                            />
                        ) : (
                            <Select
                                label={i18n.city}
                                options={cities}
                                value={newCode}
                                onChange={v => setNewCode(v)}
                                keyValue='id'
                                displayWithCode
                            />
                        )}
                    </Grid>
                    <Grid container size={6} spacing={4}>
                        <Button
                            onClick={handleAdd}
                            variant='contained'
                        >
                            {i18n.add}
                        </Button>
                        <Button
                            variant='contained'
                            component='label'
                        >
                            {i18n.importLabelStation}
                            <input
                                type='file'
                                accept='.csv'
                                hidden
                                onChange={onChangeBssFile}
                            />
                        </Button>
                    </Grid>
                </Grid>
                <Grid container justifyContent='space-between' spacing={2} sx={{ paddingTop: '10px', paddingBottom: '10px' }}>
                    <Grid size={9}>
                        {(oldCodeWithoutDesignation || isNotBss) && (
                            <Grid container alignItems='center' spacing={2}>
                                <Grid size={1}>
                                    <Warning sx={{ color: 'orange' }} />
                                </Grid>
                                <Grid size={11}>
                                    <h6>
                                        {oldCodeWithoutDesignation
                                            ? i18n.oldCodeWithoutDesignationMessage
                                            : i18n.isNotBssCode}
                                    </h6>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                <Stack spacing={4}>
                    <CardTable
                        headers={['code']}
                        rows={stationsCodes}
                        title={ filters.stationsMode === STATIONS ? i18n.credentials : i18n[filters.stationsMode] }
                        lineActions={[
                            { icon: 'delete', onClick: onDeletePiezoCode },
                        ]}
                        actions={[{
                            icon: 'download',
                            onClick: () => exportFile({
                                data: [{ ...(stationsCodes[0]), headers: ['code'] }, ...(stationsCodes.slice(1, stationsCodes.length))],
                                titleFile: i18n.credentials,
                            }),
                            tooltip: i18n.download,
                        }]}
                        displayHeaders={false}
                    />
                </Stack>
            </StyledFieldSet>
        </>
    )
}

AddPiezoStepOptionsTreatmentAdes.propTypes = {
    filters: PropTypes.any,
    changeFilters: PropTypes.any,
    jobDataTypes: PropTypes.any,
    station: PropTypes.any,
    changeStation: PropTypes.func,
    setJobDataTypes: PropTypes.func,
    newJob: PropTypes.any,
    setNewJob: PropTypes.func,
    listStation: PropTypes.any,
    setListStation: PropTypes.func,
}

export default AddPiezoStepOptionsTreatmentAdes